import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelFrench_osx: KeyLabel[] = [
  {
    code: 4,
    label: 'Q',
    meta: [
      {
        label: '‡',
        modifiers: MOD.ALT,
      },
      {
        label: 'Ω',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'Ω',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 5,
    label: 'B',
    meta: [
      {
        label: 'ß',
        modifiers: MOD.ALT,
      },
      {
        label: '∫',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '∫',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 6,
    label: 'C',
    meta: [
      {
        label: '©',
        modifiers: MOD.ALT,
      },
      {
        label: '¢',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '¢',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 7,
    label: 'D',
    meta: [
      {
        label: '∂',
        modifiers: MOD.ALT,
      },
      {
        label: '∆',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '∆',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: 'Ê',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'F',
    meta: [
      {
        label: 'ƒ',
        modifiers: MOD.ALT,
      },
      {
        label: '·',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '·',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 10,
    label: 'G',
    meta: [
      {
        label: 'ﬁ',
        modifiers: MOD.ALT,
      },
      {
        label: 'ﬂ',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'ﬂ',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 11,
    label: 'H',
    meta: [
      {
        label: 'Ì',
        modifiers: MOD.ALT,
      },
      {
        label: 'Î',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'Î',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 12,
    label: 'I',
    meta: [
      {
        label: 'î',
        modifiers: MOD.ALT,
      },
      {
        label: 'ï',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'ï',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 13,
    label: 'J',
    meta: [
      {
        label: 'Ï',
        modifiers: MOD.ALT,
      },
      {
        label: 'Í',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'Í',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 14,
    label: 'K',
    meta: [
      {
        label: 'È',
        modifiers: MOD.ALT,
      },
      {
        label: 'Ë',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'Ë',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 15,
    label: 'L',
    meta: [
      {
        label: '¬',
        modifiers: MOD.ALT,
      },
      {
        label: '|',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 16,
    label: ',',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '∞',
        modifiers: MOD.ALT,
      },
      {
        label: '¿',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '¿',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 17,
    label: 'N',
    meta: [
      {
        label: '~ (dead)',
        modifiers: MOD.ALT,
      },
      {
        label: 'ı',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'ı',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 18,
    label: 'O',
    meta: [
      {
        label: 'Œ',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 19,
    label: 'P',
    meta: [
      {
        label: 'π',
        modifiers: MOD.ALT,
      },
      {
        label: '∏',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '∏',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 20,
    label: 'A',
    meta: [
      {
        label: 'Æ',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 21,
    label: 'R',
    meta: [
      {
        label: '®',
        modifiers: MOD.ALT,
      },
      {
        label: '‚',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '‚',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 22,
    label: 'S',
    meta: [
      {
        label: 'Ò',
        modifiers: MOD.ALT,
      },
      {
        label: '∑',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '∑',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 23,
    label: 'T',
    meta: [
      {
        label: '†',
        modifiers: MOD.ALT,
      },
      {
        label: '™',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '™',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 24,
    label: 'U',
    meta: [
      {
        label: 'º',
        modifiers: MOD.ALT,
      },
      {
        label: 'ª',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'ª',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 25,
    label: 'V',
    meta: [
      {
        label: '◊',
        modifiers: MOD.ALT,
      },
      {
        label: '√',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '√',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 26,
    label: 'Z',
    meta: [
      {
        label: 'Â',
        modifiers: MOD.ALT,
      },
      {
        label: 'Å',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'Å',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 27,
    label: 'X',
    meta: [
      {
        label: '≈',
        modifiers: MOD.ALT,
      },
      {
        label: '⁄',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '⁄',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 28,
    label: 'Y',
    meta: [
      {
        label: 'Ú',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 29,
    label: 'W',
    meta: [
      {
        label: '‹',
        modifiers: MOD.ALT,
      },
      {
        label: '›',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '›',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 30,
    label: '&',
    meta: [
      {
        label: '1',
        modifiers: MOD.SFT,
      },
      {
        label: '1',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ' (Apple logo)',
        modifiers: MOD.ALT,
      },
      {
        label: '´ (dead)',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '´ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: 'é',
    meta: [
      {
        label: '2',
        modifiers: MOD.SFT,
      },
      {
        label: '2',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'ë',
        modifiers: MOD.ALT,
      },
      {
        label: '„',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '„',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '"',
    meta: [
      {
        label: '3',
        modifiers: MOD.SFT,
      },
      {
        label: '3',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '“',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: "'",
    meta: [
      {
        label: '4',
        modifiers: MOD.SFT,
      },
      {
        label: '4',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '‘',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: '(',
    meta: [
      {
        label: '5',
        modifiers: MOD.SFT,
      },
      {
        label: '5',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '{',
        modifiers: MOD.ALT,
      },
      {
        label: '[',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '[',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: '§',
    meta: [
      {
        label: '6',
        modifiers: MOD.SFT,
      },
      {
        label: '6',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¶',
        modifiers: MOD.ALT,
      },
      {
        label: 'å',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'å',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: 'è',
    meta: [
      {
        label: '7',
        modifiers: MOD.SFT,
      },
      {
        label: '7',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '«',
        modifiers: MOD.ALT,
      },
      {
        label: '»',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '»',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '!',
    meta: [
      {
        label: '8',
        modifiers: MOD.SFT,
      },
      {
        label: '8',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¡',
        modifiers: MOD.ALT,
      },
      {
        label: 'Û',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'Û',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: 'ç',
    meta: [
      {
        label: '9',
        modifiers: MOD.SFT,
      },
      {
        label: '9',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'Ç',
        modifiers: MOD.ALT,
      },
      {
        label: 'Á',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'Á',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 39,
    label: 'à',
    meta: [
      {
        label: '0',
        modifiers: MOD.SFT,
      },
      {
        label: '0',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'Ø',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: ')',
    meta: [
      {
        label: '°',
        modifiers: MOD.SFT,
      },
      {
        label: '°',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '}',
        modifiers: MOD.ALT,
      },
      {
        label: ']',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '—',
        modifiers: MOD.ALT,
      },
      {
        label: '–',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '–',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: '^',
    meta: [
      {
        label: '¨ (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '¨ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'Ô',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: '$',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '€',
        modifiers: MOD.ALT,
      },
      {
        label: '¥',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '¥',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: '`',
    meta: [
      {
        label: '£',
        modifiers: MOD.SFT,
      },
      {
        label: '£',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 51,
    label: 'M',
    meta: [
      {
        label: 'µ',
        modifiers: MOD.ALT,
      },
      {
        label: 'Ó',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'Ó',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 52,
    label: 'ù',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'Ù',
        modifiers: MOD.ALT,
      },
      {
        label: '‰',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '‰',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: '@',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '•',
        modifiers: MOD.ALT,
      },
      {
        label: 'Ÿ',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'Ÿ',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 54,
    label: ';',
    meta: [
      {
        label: '.',
        modifiers: MOD.SFT,
      },
      {
        label: '.',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '…',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 55,
    label: ':',
    meta: [
      {
        label: '/',
        modifiers: MOD.SFT,
      },
      {
        label: '/',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '÷',
        modifiers: MOD.ALT,
      },
      {
        label: '(backslash)',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '(backslash)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 56,
    label: '=',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '≠',
        modifiers: MOD.ALT,
      },
      {
        label: '±',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '±',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 100,
    label: '<',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '≤',
        modifiers: MOD.ALT,
      },
      {
        label: '≥',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '≥',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 528,
    label: '?',
  },
  {
    code: 542,
    label: '1',
  },
  {
    code: 543,
    label: '2',
  },
  {
    code: 544,
    label: '3',
  },
  {
    code: 545,
    label: '4',
  },
  {
    code: 546,
    label: '5',
  },
  {
    code: 547,
    label: '6',
  },
  {
    code: 548,
    label: '7',
  },
  {
    code: 549,
    label: '8',
  },
  {
    code: 550,
    label: '9',
  },
  {
    code: 551,
    label: '0',
  },
  {
    code: 557,
    label: '°',
  },
  {
    code: 558,
    label: '_',
  },
  {
    code: 559,
    label: '¨ (dead)',
  },
  {
    code: 560,
    label: '*',
  },
  {
    code: 562,
    label: '£',
  },
  {
    code: 564,
    label: '%',
  },
  {
    code: 565,
    label: '#',
  },
  {
    code: 566,
    label: '.',
  },
  {
    code: 567,
    label: '/',
  },
  {
    code: 568,
    label: '+',
  },
  {
    code: 612,
    label: '>',
  },
  {
    code: 1028,
    label: '‡',
  },
  {
    code: 1029,
    label: 'ß',
  },
  {
    code: 1030,
    label: '©',
  },
  {
    code: 1031,
    label: '∂',
  },
  {
    code: 1032,
    label: 'Ê',
  },
  {
    code: 1033,
    label: 'ƒ',
  },
  {
    code: 1034,
    label: 'ﬁ',
  },
  {
    code: 1035,
    label: 'Ì',
  },
  {
    code: 1036,
    label: 'î',
  },
  {
    code: 1037,
    label: 'Ï',
  },
  {
    code: 1038,
    label: 'È',
  },
  {
    code: 1039,
    label: '¬',
  },
  {
    code: 1040,
    label: '∞',
  },
  {
    code: 1041,
    label: '~ (dead)',
  },
  {
    code: 1042,
    label: 'Œ',
  },
  {
    code: 1043,
    label: 'π',
  },
  {
    code: 1044,
    label: 'Æ',
  },
  {
    code: 1045,
    label: '®',
  },
  {
    code: 1046,
    label: 'Ò',
  },
  {
    code: 1047,
    label: '†',
  },
  {
    code: 1048,
    label: 'º',
  },
  {
    code: 1049,
    label: '◊',
  },
  {
    code: 1050,
    label: 'Â',
  },
  {
    code: 1051,
    label: '≈',
  },
  {
    code: 1052,
    label: 'Ú',
  },
  {
    code: 1053,
    label: '‹',
  },
  {
    code: 1054,
    label: ' (Apple logo)',
  },
  {
    code: 1055,
    label: 'ë',
  },
  {
    code: 1056,
    label: '“',
  },
  {
    code: 1057,
    label: '‘',
  },
  {
    code: 1058,
    label: '{',
  },
  {
    code: 1059,
    label: '¶',
  },
  {
    code: 1060,
    label: '«',
  },
  {
    code: 1061,
    label: '¡',
  },
  {
    code: 1062,
    label: 'Ç',
  },
  {
    code: 1063,
    label: 'Ø',
  },
  {
    code: 1069,
    label: '}',
  },
  {
    code: 1070,
    label: '—',
  },
  {
    code: 1071,
    label: 'Ô',
  },
  {
    code: 1072,
    label: '€',
  },
  {
    code: 1075,
    label: 'µ',
  },
  {
    code: 1076,
    label: 'Ù',
  },
  {
    code: 1077,
    label: '•',
  },
  {
    code: 1078,
    label: '…',
  },
  {
    code: 1079,
    label: '÷',
  },
  {
    code: 1080,
    label: '≠',
  },
  {
    code: 1124,
    label: '≤',
  },
  {
    code: 1540,
    label: 'Ω',
  },
  {
    code: 1541,
    label: '∫',
  },
  {
    code: 1542,
    label: '¢',
  },
  {
    code: 1543,
    label: '∆',
  },
  {
    code: 1545,
    label: '·',
  },
  {
    code: 1546,
    label: 'ﬂ',
  },
  {
    code: 1547,
    label: 'Î',
  },
  {
    code: 1548,
    label: 'ï',
  },
  {
    code: 1549,
    label: 'Í',
  },
  {
    code: 1550,
    label: 'Ë',
  },
  {
    code: 1551,
    label: '|',
  },
  {
    code: 1552,
    label: '¿',
  },
  {
    code: 1553,
    label: 'ı',
  },
  {
    code: 1555,
    label: '∏',
  },
  {
    code: 1557,
    label: '‚',
  },
  {
    code: 1558,
    label: '∑',
  },
  {
    code: 1559,
    label: '™',
  },
  {
    code: 1560,
    label: 'ª',
  },
  {
    code: 1561,
    label: '√',
  },
  {
    code: 1562,
    label: 'Å',
  },
  {
    code: 1563,
    label: '⁄',
  },
  {
    code: 1565,
    label: '›',
  },
  {
    code: 1566,
    label: '´ (dead)',
  },
  {
    code: 1567,
    label: '„',
  },
  {
    code: 1570,
    label: '[',
  },
  {
    code: 1571,
    label: 'å',
  },
  {
    code: 1572,
    label: '»',
  },
  {
    code: 1573,
    label: 'Û',
  },
  {
    code: 1574,
    label: 'Á',
  },
  {
    code: 1581,
    label: ']',
  },
  {
    code: 1582,
    label: '–',
  },
  {
    code: 1584,
    label: '¥',
  },
  {
    code: 1587,
    label: 'Ó',
  },
  {
    code: 1588,
    label: '‰',
  },
  {
    code: 1589,
    label: 'Ÿ',
  },
  {
    code: 1591,
    label: '(backslash)',
  },
  {
    code: 1592,
    label: '±',
  },
  {
    code: 1636,
    label: '≥',
  },
  {
    code: 4624,
    label: '?',
  },
  {
    code: 4638,
    label: '1',
  },
  {
    code: 4639,
    label: '2',
  },
  {
    code: 4640,
    label: '3',
  },
  {
    code: 4641,
    label: '4',
  },
  {
    code: 4642,
    label: '5',
  },
  {
    code: 4643,
    label: '6',
  },
  {
    code: 4644,
    label: '7',
  },
  {
    code: 4645,
    label: '8',
  },
  {
    code: 4646,
    label: '9',
  },
  {
    code: 4647,
    label: '0',
  },
  {
    code: 4653,
    label: '°',
  },
  {
    code: 4654,
    label: '_',
  },
  {
    code: 4655,
    label: '¨ (dead)',
  },
  {
    code: 4656,
    label: '*',
  },
  {
    code: 4658,
    label: '£',
  },
  {
    code: 4660,
    label: '%',
  },
  {
    code: 4661,
    label: '#',
  },
  {
    code: 4662,
    label: '.',
  },
  {
    code: 4663,
    label: '/',
  },
  {
    code: 4664,
    label: '+',
  },
  {
    code: 4708,
    label: '>',
  },
  {
    code: 5636,
    label: 'Ω',
  },
  {
    code: 5637,
    label: '∫',
  },
  {
    code: 5638,
    label: '¢',
  },
  {
    code: 5639,
    label: '∆',
  },
  {
    code: 5641,
    label: '·',
  },
  {
    code: 5642,
    label: 'ﬂ',
  },
  {
    code: 5643,
    label: 'Î',
  },
  {
    code: 5644,
    label: 'ï',
  },
  {
    code: 5645,
    label: 'Í',
  },
  {
    code: 5646,
    label: 'Ë',
  },
  {
    code: 5647,
    label: '|',
  },
  {
    code: 5648,
    label: '¿',
  },
  {
    code: 5649,
    label: 'ı',
  },
  {
    code: 5651,
    label: '∏',
  },
  {
    code: 5653,
    label: '‚',
  },
  {
    code: 5654,
    label: '∑',
  },
  {
    code: 5655,
    label: '™',
  },
  {
    code: 5656,
    label: 'ª',
  },
  {
    code: 5657,
    label: '√',
  },
  {
    code: 5658,
    label: 'Å',
  },
  {
    code: 5659,
    label: '⁄',
  },
  {
    code: 5661,
    label: '›',
  },
  {
    code: 5662,
    label: '´ (dead)',
  },
  {
    code: 5663,
    label: '„',
  },
  {
    code: 5666,
    label: '[',
  },
  {
    code: 5667,
    label: 'å',
  },
  {
    code: 5668,
    label: '»',
  },
  {
    code: 5669,
    label: 'Û',
  },
  {
    code: 5670,
    label: 'Á',
  },
  {
    code: 5677,
    label: ']',
  },
  {
    code: 5678,
    label: '–',
  },
  {
    code: 5680,
    label: '¥',
  },
  {
    code: 5683,
    label: 'Ó',
  },
  {
    code: 5684,
    label: '‰',
  },
  {
    code: 5685,
    label: 'Ÿ',
  },
  {
    code: 5687,
    label: '(backslash)',
  },
  {
    code: 5688,
    label: '±',
  },
  {
    code: 5732,
    label: '≥',
  },
];
